import React from 'react';
import { useLocation } from 'react-router-dom';
import { useCatalystChat } from './useCatalystChat';

// Hosts the chat session app-wide so collapsing the drawer or navigating between
// pages never tears down an in-flight stream. Header2 reads `open`/`toggle`;
// ChatPanel reads the messages + send/reset.
export const ChatSessionContext = React.createContext(null);

export default function ChatSessionProvider({ children }) {
  const [open, setOpen] = React.useState(false);
  const chat = useCatalystChat();
  const location = useLocation();

  React.useEffect(() => {
    setOpen(false);
    chat.reset();
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const value = React.useMemo(
    () => ({
      open,
      setOpen,
      toggle: () => setOpen((o) => !o),
      ...chat,
    }),
    [open, chat],
  );

  return <ChatSessionContext.Provider value={value}>{children}</ChatSessionContext.Provider>;
}
